export default __webpack_public_path__ + "static/media/ic_attachment.e3ed33a9.svg";